import React from 'react'
import { SplitView, LeftPanel, RightPanel } from '../../components/SplitView'
import WorkSummaryListViewContainer from '../../components/WorkSummaryListView'
import WorkSummaryDetailView from './WorkSummaryDetailView'

export default class WorkSummarySplitView extends React.Component {
  state = {
    activeWorkSummary: undefined,
  }

  handleWorkSummaryClick = (workSummary) => {
    this.setState({
      activeWorkSummary: workSummary,
    })
  }

  render() {
    return (
      <div className="flex flex-col md:flex-row h-full gap-4 p-4">
        <LeftPanel>
          <WorkSummaryListViewContainer
            onWorkSummaryClick={this.handleWorkSummaryClick}
            onBack={this.props.onBack}
          />
        </LeftPanel>
        <RightPanel>
          <div className="bg-white rounded-lg shadow-sm h-full overflow-auto">
            <WorkSummaryDetailView workSummary={this.state.activeWorkSummary} />
          </div>
        </RightPanel>
      </div>
    )
  }
}
